import { List } from 'immutable';
import Brand, { UserBrands } from 'records/Brand';
import Location from 'records/Location';
import BaseList from 'records/BaseList';

import { REHYDRATE } from 'redux-persist/constants';
import {
  USER_BRANDS_UPDATE_ACTION_SUCCESS,
  USER_BRAND_UPDATE_ACTION_SUCCESS,
  USER_BRAND_ADD_ACTION_SUCCESS,
  USER_BRANDS_UPDATE_ACTION_ERROR,
  USER_BRAND_ADD_LOCATION_ACTION_SUCCESS,
  USER_BRAND_UPDATE_LOCATION_ACTION_SUCCESS,
  USER_BRANDS_RESET_STATE,
  USER_BRAND_ADD_BRAND_PROPERTY,
  USER_BRAND_REMOVE_BRAND_PROPERTY,
  USER_BRAND_UPDATE_BRAND_PROPERTY,
} from 'actions/user-brands';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [USER_BRANDS_UPDATE_ACTION_SUCCESS]: (state, action) => {
    const userBrandsData = UserBrands(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: userBrandsData,
    });
  },
  [USER_BRAND_UPDATE_ACTION_SUCCESS]: (state, action) => {
    const userBrandsData = Brand.updateUserBrands(state.data, new Brand({
      ...action.data,
      locations: Brand.getCurrentUserBrand(state.data).get('locations').toJS(),
    }));
    return state.merge({
      loading: false,
      errorMessage: null,
      data: userBrandsData,
    });
  },
  [USER_BRAND_ADD_ACTION_SUCCESS]: (state, action) => {
    const userBrandsData = Brand.addUserBrand(state.data, new Brand(action.data));
    return state.merge({
      loading: false,
      errorMessage: null,
      data: userBrandsData,
    });
  },
  [USER_BRANDS_UPDATE_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [USER_BRAND_UPDATE_LOCATION_ACTION_SUCCESS]: (state, action) => {
    const userBrandsData = Brand.updateUserBrandsLocation(state.data, new Location(action.data));
    return state.merge({
      loading: false,
      errorMessage: null,
      data: userBrandsData,
    });
  },
  [USER_BRAND_ADD_LOCATION_ACTION_SUCCESS]: (state, action) => {
    const userBrandsData = Brand.addUserBrandLocation(state.data, new Location(action.data));
    return state.merge({
      loading: false,
      errorMessage: null,
      data: userBrandsData,
    });
  },
  [USER_BRAND_ADD_BRAND_PROPERTY]: (state, action) => {
    const userBrandsData = Brand.addUserBrandProperty(state.data, action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: userBrandsData,
    });
  },
  [USER_BRAND_REMOVE_BRAND_PROPERTY]: (state, action) => {
    const userBrandsData = Brand.removeUserBrandProperty(state.data, action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: userBrandsData,
    });
  },
  [USER_BRANDS_RESET_STATE]: () => {
    return initialState;
  },
  [REHYDRATE]: (state, action) => {
    const userBrandsPayload = action.payload.userBrands;
    if (userBrandsPayload) {
      const userBrandsData = UserBrands(userBrandsPayload.data);
      return new BaseList({
        loading: userBrandsPayload.loading,
        errorMessage: userBrandsPayload.errorMessage,
        data: userBrandsData,
      });
    }
    return state;
  },
  [USER_BRAND_UPDATE_BRAND_PROPERTY]: (state, action) => {
    const userBrandsData = Brand.updateUserBrandProperty(state.data, action.payload);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: userBrandsData,
    });
  },
};

export default function userBrands(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
